import {HttpCrudDataSource} from '../../core/data-source/http-crud.data-source';

export class AboutCompanyCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/accounts/full';
}
